var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestFailedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-47.7%",
    y: "-34.1%",
    width: "195.5%",
    height: "195.5%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 15,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.878431373 0 0 0 0 0.925490196 0 0 0 0 0.937254902 0 0 0 1 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 55,
    cy: 55,
    r: 55
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 15)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#CFD9DD",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.2 83.8c-8.947 0-17.47 3.79-23.388 10.4a2.402 2.402 0 0 0 1.788 4c.658 0 1.315-.269 1.788-.8 5.009-5.594 12.23-8.8 19.812-8.8 7.584 0 14.806 3.206 19.812 8.8a2.4 2.4 0 1 0 3.576-3.2C102.672 87.591 94.15 83.8 85.2 83.8zM114 55a2.4 2.4 0 0 0-2.4 2.4c0 3.97-3.23 7.2-7.2 7.2s-7.2-3.23-7.2-7.2a2.4 2.4 0 1 0-4.8 0c0 6.617 5.383 12 12 12s12-5.383 12-12A2.4 2.4 0 0 0 114 55zm-36 2.4a2.4 2.4 0 1 0-4.8 0c0 3.97-3.23 7.2-7.2 7.2s-7.2-3.23-7.2-7.2a2.4 2.4 0 1 0-4.8 0c0 6.617 5.383 12 12 12s12-5.383 12-12z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestFailedIcon);
export default __webpack_public_path__ + "static/media/test-failed-icon.2dd546c5.svg";
export { ForwardRef as ReactComponent };